// UI settings remembered in this browser (localStorage, keys "portfel.*").
export const store = {
  get<T>(k: string, d: T): T {
    try {
      const v = localStorage.getItem("portfel." + k);
      return v === null ? d : (JSON.parse(v) as T);
    } catch {
      return d;
    }
  },
  set(k: string, v: unknown): void {
    try {
      localStorage.setItem("portfel." + k, JSON.stringify(v));
    } catch {
      /* private browsing mode */
    }
  },
  remove(k: string): void {
    try {
      localStorage.removeItem("portfel." + k);
    } catch {
      /* */
    }
  },
};
